

const gridLayout = {
  gridSelector: null,
  itemSelector: '.grid__item',
  gridItems: null,
  gridItemsArray: null,
  msnryGrid: null,
  useInterSectionObserver: true,
  useFilters: true,
  aFilters: null,
  aDropdowns: null,
  observer: null,
  imgLoaded: null,
  create: () => {
    gridLayout.gridSelector = document.querySelector('.js-grid');
    gridLayout.msnryGrid = new Masonry(gridLayout.gridSelector, {
      itemSelector: gridLayout.itemSelector,
      columnWidth: '.grid__sizer',
      percentPosition: true,
      transitionDuration: 0,
    });

    gridLayout.imgLoaded = imagesLoaded(gridLayout.gridSelector);
    gridLayout.imgLoaded.on('progress', (instance, image) => {
      if (image.isLoaded) {
        gridLayout.reloadLayout();
      }
    });

    gridLayout.gridItems = document.querySelectorAll(gridLayout.itemSelector);
    gridLayout.created();
  },
  created: () => {
    if (gridLayout.useInterSectionObserver) {
      gridLayout.initializeObserver();
    }

    if (gridLayout.useFilters) {
      gridLayout.initializeFilters();
    }
  },
  initializeObserver: () => {
    const observeTargets = document.querySelectorAll('.grid__item');
    IntersectionObserver.prototype.POLL_INTERVAL = 100;

    const options = {
      rootMargin: '0px',
      treshold: 0.5,
    };

    gridLayout.observer = new IntersectionObserver(gridLayout.loadItems, options);

    for (let i = 0; i < observeTargets.length; i += 1) {
      gridLayout.observer.observe(observeTargets[i]);
    }
  },
  initializeFilters: () => {
    gridLayout.aFilters = document.querySelectorAll('.js-filter');
    gridLayout.aDropdowns = document.querySelectorAll('.js-dropdown');

    if (window.location.search) {
        const style = decodeURI(window.location.search.substring(1).split('=')[1]).replaceAll("%26", "&").replaceAll("+", " ");
        console.log(style)
        const hasKnownFilter = Array.prototype.slice.call(gridLayout.aFilters).filter((filterItem) => {
        const sFilterItemFilters = filterItem.getAttribute('data-filter');

        if (typeof sFilterItemFilters !== 'undefined' && sFilterItemFilters !== null) {
          const aFilterItemFilters = sFilterItemFilters.split('|');

          return aFilterItemFilters.indexOf(style) !== -1;
        }

        return false;
      });

      if (hasKnownFilter.length) {
        gridLayout.filterItems(style);
      }
    }

    for (let i = 0; i < gridLayout.aFilters.length; i += 1) {
      gridLayout.aFilters[i].addEventListener('click', (event) => {
        const styles = gridLayout.aFilters[i].getAttribute('data-filter');

        gridLayout.setActiveFilter(gridLayout.aFilters[i]);
        gridLayout.filterItems(styles);

        if (gridLayout.aFilters[i].href/*.includes("?")*/) {
            window.history.replaceState(undefined, undefined, gridLayout.aFilters[i].href);
        }

        event.preventDefault();
      });
    }
  },
  setActiveFilter: (filterItem) => {
    const oFilterDropdown = filterItem.parentNode.parentNode.previousElementSibling;
    for (let i = 0; i < gridLayout.aFilters.length; i += 1) {
      gridLayout.aFilters[i].classList.remove('active');
    }

    for (let d = 0; d < gridLayout.aDropdowns.length; d += 1) {
      gridLayout.aDropdowns[d].querySelector('.dropdown__toggle').classList.remove('active');
    }

    filterItem.classList.add('active');
    if (oFilterDropdown !== null) {
      oFilterDropdown.classList.add('active');
    }
  },
  filterItems: (styles) => {
    let filteredItems;
    const items = document.querySelectorAll(gridLayout.itemSelector);
    gridLayout.hideItems(items);

    gridLayout.gridItemsArray = Array.prototype.slice.call(items);

    if (styles !== null) {
      filteredItems = gridLayout.gridItemsArray.filter((item) => {
        const suppliedStyles = styles.split('|');
        const itemStyles = item.getAttribute('data-style') ? item.getAttribute('data-style').split('|') : [];
        let matchedStyle = false;

        for (let i = 0; i < itemStyles.length; i += 1) {
          if (suppliedStyles.indexOf(itemStyles[i]) !== -1) {
            matchedStyle = true;
            break;
          }
        }

        return matchedStyle;
      });
    } else {
      filteredItems = gridLayout.gridItemsArray.filter(item => item.getAttribute('data-prio') !== 'low');
    }

    gridLayout.showItems(filteredItems);
  },
  loadItems: (entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting && !entry.target.classList.contains('visible')) {
        entry.target.classList.add('visible');
        gridLayout.loadImage(entry.target);
      }
    });
  },
  hideItems: (gridItems) => {
    for (let i = 0; i < gridItems.length; i += 1) {
      gridItems[i].classList.add('hidden');
    }

    gridLayout.reloadLayout();
  },
  showItems: (gridItems) => {
    for (let i = 0; i < gridItems.length; i += 1) {
      gridItems[i].classList.remove('hidden');
    }

    gridLayout.reloadLayout();
  },
  reloadLayout: () => {
    gridLayout.msnryGrid.layout();
  },
  loadImage: (gridItem) => {
    const itemImg = gridItem.querySelector('img');
    const itemImgSrc = itemImg.getAttribute('data-src');
    if (itemImgSrc !== null && itemImgSrc !== '') {
      itemImg.setAttribute('src', itemImgSrc);

      const imgLoaded = imagesLoaded(itemImg);
      imgLoaded.on('done', () => {
        gridLayout.reloadLayout();
      });
    }
  },
};

gridLayout.create();
